import React from 'react';
import type { RouteProps } from 'react-router';
import { Route } from 'react-router';

import DynamicImport from 'components/common/dynamic.import';

const UnsubscriptionPage = (props: RouteProps) => <DynamicImport load={() => import('./unsubscription')} {...props} />;

export const mailingRoutes = () => <Route path="mailing/unsubscribe/:id/:email" component={UnsubscriptionPage} />;
